import styled from 'styled-components';
import { TypeStyle } from '../TypeStyle';
export const StyledText = styled(TypeStyle.BodySmall) `
  color: ${o => o.disabled && o.theme.color.deprecated.obsidianLighter};
  font-weight: ${o => o.checked ? o.theme.typography.font.weight['600'] : o.theme.typography.font.weight['400']};
`;
//# sourceMappingURL=styles.js.map